export const SANDBOX_BANNER_EXCLUDED_ROUTES = [
    '/accountStatus',
]

export const SANDBOX_LIVE_TOGGLE_EXCLUDED_ROUTES = [
    '/accountStatus',
]
